import React, { Component } from 'react';
import { TimelineLite, TweenLite } from 'gsap';
import Link from 'gatsby-link';
import sortChaptersById from '../exhibition/sortChaptersById';

import HeaderSocial from './HeaderSocial';
import SocialLinks from './SocialLinks';
import DropdownNav from './DropdownNav';

import style from './MainNav.module.scss';

const ListLink = ({
  to,
  className,
  children,
  title,
  sortedChapters,
  isDropdownNavOpen,
  handleDropdownChange,
  mainNavColor,
  isMenuCollapsed,
  location,
  timelineData,
  handleChapterNav,
  registerEraSkip,
}) => {
  let url = to;

  const internal = /^\/(?!\/)/.test(url);
  if (internal) {
    return (
      <li
        className={`${className} ${style.navItem} ${
          (url.indexOf('exhibition') !== -1 &&
            location.pathname.indexOf('exhibition') !== -1) ||
          (url.indexOf('timeline') !== -1 &&
            location.pathname.indexOf('timeline') !== -1)
            ? ' js-navItemActive ' + style.navItemActive
            : 'js-navItem'
        }`}
      >
        <Link
          to={url}
          activeClassName={`activeNavItem ${style.active}`}
          className={`${style.navLink}`}
        >
          <span className={style.navLinkInner}>{children}</span>
        </Link>
        {url.indexOf('exhibition') !== -1 && (
          <DropdownNav
            isCurrentPage={location.pathname.indexOf('exhibition') !== -1}
            isMenuCollapsed={isMenuCollapsed}
            chapters={sortedChapters}
            isDropdownNavOpen={isDropdownNavOpen}
            handleDropdownChange={handleDropdownChange}
            mainNavColor={mainNavColor}
            handleChapterNav={handleChapterNav}
            registerEraSkip={registerEraSkip}
            isDesktop
            // handleChapterNavigation={this.handleChapterNavigation}
          />
        )}
        {url.indexOf('timeline') !== -1 && (
          <DropdownNav
            isCurrentPage={location.pathname.indexOf('timeline') !== -1}
            isMenuCollapsed={isMenuCollapsed}
            isDropdownNavOpen={isDropdownNavOpen}
            handleDropdownChange={handleDropdownChange}
            mainNavColor={mainNavColor}
            isDesktop
            registerEraSkip={registerEraSkip}
            eras={timelineData.edges[0].node.eras} // Replace with Timeline data
            timelinePath={timelineData.edges[0].node.path}
            // handleChapterNavigation={this.handleChapterNavigation} Replace with anchor links
          />
        )}
      </li>
    );
  } else {
    return (
      <li
        className={`${className} ${style.navItem} ${
          (url.indexOf('exhibition') !== -1 &&
            location.pathname.indexOf('exhibition') !== -1) ||
          (url.indexOf('timeline') !== -1 &&
            location.pathname.indexOf('timeline') !== -1)
            ? ' js-navItemActive ' + style.navItemActive
            : 'js-navItem'
        }`}
      >
        <a
          href={url}
          className={`${style.navLink}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className={style.navLinkInner}>{children}</span>
        </a>
      </li>
    );
  }
};

class MainNav extends Component {
  componentWillMount() {
    const chapterIds = this.props.exhibitionData.edges[0].node.chapters;
    const chapters = this.props.chapterData.edges.map(edge => edge.node);
    this.sortedChapters = sortChaptersById(chapterIds, chapters);
  }

  expandNav() {
    const activeNavDuration =
      this.props.location.pathname.indexOf('timeline') !== -1 ? 1.0 : 1.15;

    const menuExpand = new TimelineLite();
    TweenLite.to('.js-navItemActive', activeNavDuration, {
      x: 0,
      ease: Cubic.easeInOut,
      opacity: 1,
    });

    menuExpand
      .staggerTo(
        '.js-navItem:not(.js-navItemActive)',
        0.8,
        {
          x: 0,
          opacity: 1,
          ease: Cubic.easeInOut,
        },
        -0.07
      )
      .to(
        '.js-dropdownNav',
        0.8,
        {
          x: 0,
          opacity: 0,
        },
        '-=0.95'
      );
  }
  collapseNav = progress => {
    // if map inactive
    // this.props.location.pathname.indexOf('timeline') !== -1 ? 45 : 135;
    const activeNavX =
      this.props.location.pathname.indexOf('timeline') !== -1 ? 290 : 380;

    const activeNavDuration =
      this.props.location.pathname.indexOf('timeline') !== -1 ? 1.0 : 1.15;

    const activeNavPos =
      this.props.location.pathname.indexOf('timeline') !== -1
        ? '-=0.5'
        : '-=0.4';
    const menuCollapse = new TimelineLite();
    // this.menuCollapse.timeScale(1);
    menuCollapse
      .staggerFromTo(
        '.js-navItem',
        0.8,
        {
          x: 0,
          opacity: 1,
          ease: Cubic.easeInOut,
        },
        {
          x: 50,
          opacity: 0,
          ease: Cubic.easeInOut,
        },
        -0.07
      )
      .fromTo(
        '.js-navItemActive',
        activeNavDuration,
        {
          x: 0,
          ease: Cubic.easeInOut,
          opacity: 1,
        },
        {
          x: activeNavX,
          ease: Cubic.easeInOut,
          opacity: 1,
        },
        activeNavPos
      )
      .fromTo(
        '.js-dropdownNav',
        0.8,
        {
          x: -20,
          opacity: 0,
        },
        {
          x: 0,
          opacity: 1,
        },
        '-=0.95'
      );
    if (progress) {
      menuCollapse.progress(progress);
    }
  };

  componentDidMount() {
    // if (window.innerWidth <= 1280) {
    //   // this.menuCollapse.clear();
    //   // this.menuCollapse.set('.js-hamburgerMenu', { opacity: 1 });
    // } else {
    if (this.props.isMenuCollapsed) {
      this.collapseNav(1);
    }
    // }
  }

  componentDidUpdate(prevProps) {
    // reset nav when gong from exhibition to timeline
    if (prevProps.menuCollapsedPage && this.props.menuCollapsedPage) {
      if (
        prevProps.location.pathname.indexOf('exhibition') !== -1 &&
        this.props.location.pathname.indexOf('timeline') !== -1
      ) {
        this.collapseNav(1);
      }
    }
    if (prevProps.isMenuCollapsed !== this.props.isMenuCollapsed) {
      if (this.props.isMenuCollapsed) {
        this.collapseNav();

        if (this.props.isSocialExpanded) {
          setTimeout(() => {
            this.props.handleSocialExpanded(false);
          }, 500);
        }
      } else {
        this.expandNav();
      }
    }
    // if (prevProps.isMobileMenu !== this.props.isMobileMenu) {
    //   if (this.props.isMobileMenu) {
    //     if (this.menuCollapse) {
    //       this.menuCollapse.clear();
    //     }
    //
    //     // this.menuCollapse.set('.js-hamburgerMenu', { opacity: 1 });
    //   }
    // }
  }

  render() {
    const {
      mainNavColor,
      isMenuCollapsed,
      isMobileMenu,
      isMobileMenuOpen,
      isDropdownNavOpen,
      handleDropdownChange,
      dropdownNavColor,
      location,
      settingsContent,
      handleSocialExpanded,
      isSocialExpanded,
      menuCollapsedPage,
      menuToggledOpen,
      timelineData,
      handleChapterNav,
      registerEraSkip,
    } = this.props;
    return (
      <div
        className={`${style.shiftLeft} ${
          menuCollapsedPage && menuToggledOpen ? style.shiftLeftActive : ''
        }`}
      >
        <ul
          className={`main-nav ${style.mainNav}
          ${
            mainNavColor === 'white'
              ? 'mainNavWhite ' + style.mainNavWhite
              : mainNavColor === 'black'
              ? 'mainNavBlack'
              : ''
          }
          ${menuCollapsedPage ? style.collapsedPage : style.notCollapsedPage}
          ${menuToggledOpen ? style.toggledOpen : ''}
          // ${isMenuCollapsed ? style.mainNavCollapsed : ''}
          ${isMobileMenuOpen ? style.mobileNavOpen : ''}`}
          ref={el => {
            this.mainNavWrapper = el;
          }}
        >
          {settingsContent.menu.map((item, i) => (
            <ListLink
              key={`navitem${item.title}`}
              to={item.path}
              title={item.title}
              className={item.title === 'About' ? style.utilityNavItem : ''}
              isMenuCollapsed={isMenuCollapsed}
              sortedChapters={this.sortedChapters}
              isDropdownNavOpen={isDropdownNavOpen}
              handleDropdownChange={handleDropdownChange}
              handleChapterNav={handleChapterNav}
              mainNavColor={mainNavColor}
              location={location}
              timelineData={timelineData}
              registerEraSkip={registerEraSkip}
            >
              {item.title}
            </ListLink>
          ))}
          <HeaderSocial
            settingsContent={settingsContent}
            handleSocialExpanded={handleSocialExpanded}
            isSocialExpanded={isSocialExpanded}
            mainNavColor={mainNavColor}
          />
          {settingsContent.social.donate ? (
            <li
              className={`js-navItem ${style.navItem} ${style.utilityNavItem}`}
            >
              <a
                href={settingsContent.social.donate}
                target="_blank"
                className={style.navLink}
              >
                Donate
              </a>
            </li>
          ) : (
            ''
          )}

          <li className={style.socialWrapper}>
            <SocialLinks redIcons data={settingsContent.social} />
          </li>
        </ul>

        <div
          className={`${
            mainNavColor === 'white'
              ? 'mobileDropdownsWhite ' + style.mobileDropdownsWhite
              : ''
          } ${style.mobileDropdowns}`}
        >
          {location.pathname.indexOf('exhibition') !== -1 && (
            <a
              href="/exhibition"
              className={`current-page ${style.currentPage}`}
            >
              Exhibition
            </a>
          )}

          {location.pathname.indexOf('timeline') !== -1 && (
            <a href="/timeline" className={`current-page ${style.currentPage}`}>
              Timeline
            </a>
          )}

          <DropdownNav
            isCurrentPage={location.pathname.indexOf('exhibition') !== -1}
            isMenuCollapsed={isMenuCollapsed}
            chapters={this.sortedChapters}
            isDropdownNavOpen={isDropdownNavOpen}
            handleDropdownChange={handleDropdownChange}
            mainNavColor={mainNavColor}
            handleChapterNav={handleChapterNav}
            registerEraSkip={registerEraSkip}
            isMobile
            eras={false}
            isMobile
          />

          <DropdownNav
            isCurrentPage={location.pathname.indexOf('timeline') !== -1}
            isMenuCollapsed={isMenuCollapsed}
            eras={timelineData.edges[0].node.eras}
            timelinePath={timelineData.edges[0].node.path}
            isDropdownNavOpen={isDropdownNavOpen}
            handleDropdownChange={handleDropdownChange}
            mainNavColor={mainNavColor}
            registerEraSkip={registerEraSkip}
            isMobile
          />
        </div>
      </div>
    );
  }
}

export default MainNav;



// WEBPACK FOOTER //
// ./src/components/global/MainNav.js